export const STORIES_EVENTS = {
  STORIES_OPENED: "web_app_stories_opened",
  FILTER_CHANGED: "web_app_stories_filter_changed",
  FILTERS_CLEARED: "web_app_stories_filters_cleared",
  SORT_CHANGED: "web_app_stories_sort_changed",
  LEVEL_SELECTED: "web_app_stories_level_selected",
  STORY_OPENED: "web_app_story_opened",
  STORY_COMPLETED: "web_app_story_completed",
  STORY_MODE_SELECTED: "web_app_story_mode_selected",
  STORY_MODE_SWITCHED: "web_app_story_mode_switched",
  STORY_RESET: "web_app_story_reset",
  STORY_INFO_OPENED: "web_app_story_info_opened",
  TRANSLATION_USED: "web_app_story_translation_used",
  WORD_TRANSLATION_SHOWN: "web_app_story_word_translation_shown",
  SENTENCE_LISTENED: "web_app_story_sentence_listened",
  SENTENCE_EXPLAINED: "web_app_story_sentence_explained",
  SENTENCE_ADDED: "web_app_story_sentence_added",
  WORD_SAVED: "web_app_story_word_saved",
  AUDIO_PLAYED: "web_app_story_audio_played",
  AUDIO_PAUSED: "web_app_story_audio_paused",
  CLOZE_ANSWERED: "web_app_cloze_story_answered",
  CLOZE_COMPLETED: "web_app_cloze_story_completed",
  STORY_RATED: "web_app_story_rated",
  STORY_FEEDBACK_SUBMITTED: "web_app_story_feedback_submitted",
  FEATURE_FEEDBACK_SENT: "web_app_feature_feedback_sent"
};

export const SMART_MODE = "smart";
export const CLOZE_MODE = "cloze";
